import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import moment from 'moment';
import SeriesProgressBar from '@/components/dashboard/seriesProgressBar'
import { seriesStatus } from '@/pages/dashboard/constants'

import BlueFilledHeart from '@/assets/icons/blueFilledHeart.png'
import LightBlueFilledHeart from '@/assets/icons/lightBlueFilledHeart.png'

import Clock from '@/assets/icons/clock.png'
import WhiteClock from '@/assets/icons/whiteClock.png'
import BlackTimer from '@/assets/icons/blackTimer.png'
import WhiteTimer from '@/assets/icons/whiteTimer.png'
import BlueTick from '@/assets/icons/blueTick.png'
import WhiteLock from '@/assets/icons/whiteLock.png'
import BlackLock from '@/assets/icons/blackLock.png'
import SmallWhiteLock from '@/assets/icons/smallWhiteLock.png'

import { useLocalTranslation } from '@/hooks/useLocalTranslation';
import { useSelector } from 'react-redux';
import { RootState } from '@/store';

import './commonSeriesExamCard.css';
import './seriesCard.css';
import { addCurrentThemeClassToEle } from '@/utils';
import { pickFirstVideoDocId } from '@/utils/pickFirstVideoDocId';
import { themes } from '@/constants/colors_v2';


export default function SeriesCard(props: any) {
    const navigate = useNavigate();
    const location = useLocation();
    /**
        seriesStatus : ["enrolled", "active", "paused", "expired", "completed"];

        Lock Icon if status is:
            enrolled || expired || paused || any one installmentOverdue

        Text on various status: 
            completed : Completed on 21st Feb, 2025
            expired : Expired on 28th Sep, 2025
            active : 
                208 remaining..Ends on22nd Apr, 2025
     */

    const { common, dashboard } = useLocalTranslation();

    const [overLayIcon, setOverLayIcon] = useState("")
    const timelineDetails = useSelector((state: RootState) => state.timelineReducer.timeline);
    const currentTheme = useSelector((state: RootState) => state.currentThemeReducer.currentTheme);



    useEffect(() => {
        updateSeriesStatus()
    }, [props.serie])


    const updateSeriesStatus = () => {
        if (props.anyOneInstallmentOverDue) {
            setOverLayIcon(WhiteLock)
            return
        }

        if (props.serie && props.serie.seriesStatus
            && (props.serie.seriesStatus === seriesStatus.paused
                || props.serie.seriesStatus === seriesStatus.enrolled)) {
                    // console.log(props.serie)
            setOverLayIcon(WhiteLock)
            return
        }

        if (isExpired()) {
            setOverLayIcon(WhiteLock)
            return
        }

        if (isCompleted()) {
            setOverLayIcon(BlueTick)
        }

    }

    const showRemaningDays = (): boolean => {
        let status = false
        if (props.serie && props.serie.seriesStatus && props.serie.remainingDays) {
            if (props.serie.seriesStatus === seriesStatus.active) {
                status = true
            }
        }
        return status
    }

    const isCompleted = (): boolean => {
        // return true // testing
        let status = false
        if (props.serie && props.serie.seriesStatus && props.serie.seriesStatus === seriesStatus.completed && props.serie.seriesCompletedAt) {
            status = true
        }
        return status

    }

    const isExpired = (): boolean => {
        let status = false
        if (props.serie && props.serie.seriesStatus && props.serie.seriesStatus === seriesStatus.expired && props.serie.createdAt && props.serie.validityDays) {
            status = true
        }
        return status
    }


    const statusMsgCon = (image: any, text: string, date: any, daysToAdd: number = -1) => {
        let dateMoment = moment.utc(date);
        if (daysToAdd > -1) {
            dateMoment = dateMoment.add(daysToAdd, 'days');
        }

        const newDate = dateMoment.format('Do MMM, YYYY');

        let useThisImg = image
        if(image === Clock){
            if(currentTheme === themes.dark){
                useThisImg = WhiteClock
            }
        }

        if(image === BlackTimer){
            if(currentTheme === themes.dark){
                useThisImg = WhiteTimer
            }
        }

        return (
            <div className={`flex items-center text-[14px] ${addCurrentThemeClassToEle(currentTheme, 'statusMsgCon')}`}>
                <img className='w-[14px] mr-[5px]' src={useThisImg} alt='img' />
                <p className='truncate'>
                    {text}
                    <span className='font-medium ml-[3px]'>
                        {newDate}
                    </span>
                </p>
            </div>
        )
    }

    const handleSeriesRedirect = () => {
        if (overLayIcon === WhiteLock) return;

        const serie = props.serie;
        if (!serie?.seriesId) {
            alert("Issue in finding series id and video id");
            return;
        }

        /** Matches watch UI: `?subscription=true` → `x-is-subscribed-series` on series APIs. */
        const asSubscribedSeries = Boolean(
            props.fromSubscription || serie.isSubscribedSeries === true
        );

        const seriesId = serie.seriesId;
        let navigate_: string;

        if (asSubscribedSeries) {
            const videoDocId = pickFirstVideoDocId(serie);
            navigate_ = `/watch?series=${seriesId}`;
            if (videoDocId) {
                navigate_ += `&video=${videoDocId}`;
            }
            if (serie.isWelcomeSeries) {
                navigate_ += "&ws=true";
            }
            navigate_ += "&subscription=true";
        } else {
            const videoDocId = serie.firstVideoDocId;
            if (!videoDocId) {
                alert("Issue in finding series id and video id");
                return;
            }
            navigate_ = `/watch?series=${seriesId}&video=${videoDocId}`;
            if (serie.isWelcomeSeries) {
                navigate_ += "&ws=true";
            }
        }

        const source = location.pathname.split("/")[1];
        navigate(navigate_, {
            state: {
                source: `/${source}`,
                purchaseId: timelineDetails?.purchaseId,
            },
        });
    }

    /** Subscription group list: title + progress bar only (0% … 100% labels via `SeriesProgressBar`). */
    const subscriptionGroupCard = Boolean(props.subscriptionGroupCard);

    const addClassAsPerCourse = (className: any) => {
        // props.source :: can be timeline || dashboard
        // console.log(props.source)
        const classNameAsPerTheme = addCurrentThemeClassToEle(currentTheme, className)
        /**
         * Possible class names : 
         * dashboard_dark_theme_seriesCardMain
         * dashboard_light_theme_seriesCardMain
         * timeline_dark_theme_seriesCardMain
         * timeline_light_theme_seriesCardMain
         */
        return props.source + "_" + classNameAsPerTheme
    }

    return (
        <div
            onClick={handleSeriesRedirect}
            style={{
                cursor: overLayIcon === WhiteLock ? 'not-allowed' : 'pointer',
            }}
            className={`seriesCardMain h-fit rounded-[7px] border 
                ${props.hideThumbnail ? "seriesCardMain--noThumb" : ""}
                ${addClassAsPerCourse('seriesCardMain')}`}
        >

            {!props.hideThumbnail ? (
                <div className="relative seriesCardMain_01">
                    <img
                        className="w-full h-full object-cover"
                        src={props.serie?.thumbnailUrl}
                        alt={"Series thumbnail"}
                    />
                    {!subscriptionGroupCard && overLayIcon != "" &&
                        <div>
                            <div className="absolute inset-0 bg-black/30 rounded-[7px]" />
                            <img
                                className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[28px]"
                                src={overLayIcon}
                                alt="Overlay icon"
                            />
                        </div>
                    }
                </div>
            ) : null}

            {/* Flexible content column */}
            <div
                className={`flex flex-col justify-center pr-[23px] overflow-hidden seriesCardMain_02 ${
                    props.hideThumbnail ? "pl-[16px]" : "pl-[10px]"
                }`}
            >
                <div className="w-full overflow-hidden">
                    <p
                        className={`seriesTitle_seriesCard font-medium truncate ${
                            subscriptionGroupCard ? "mb-0" : "mb-[5px]"
                        } ${overLayIcon === WhiteLock ? 'seriesTitle_seriesCard_lock' : 'seriesTitle_seriesCard_unlock'}`}>
                        {props.serie?.title}
                    </p>
                    {!subscriptionGroupCard && (
                        <>
                    {(props.serie.seriesStatus === seriesStatus.paused || props.serie.seriesStatus === seriesStatus.enrolled) && overLayIcon === WhiteLock &&
                        <div className='flex items-center mt-[8px]'>
                            <img
                                className='w-[16px] mr-[5px]'
                                src={currentTheme === themes.dark ? SmallWhiteLock : BlackLock} 
                                alt='BlackLock' />
                            <p className='lockMsg_seriesCard font-medium'>{dashboard.watchSection.series.lockMsg}</p>
                        </div>

                    }
                    {showRemaningDays() &&
                        <div>
                            <div className='remainingDays_seriesCard flex items-center font-medium mb-[4px] leading-[0px]'>
                                <img className='w-[14px] mr-[5px]' 
                                src={currentTheme === themes.dark ? LightBlueFilledHeart : BlueFilledHeart}
                                alt='blueFilledHeart' />
                                {props.serie.remainingDays} {common.statusText.remaining}..
                            </div>
                            {statusMsgCon(Clock, common.statusText.endsOn, props.serie.seriesEndAt)}
                        </div>
                    }

                    {isCompleted() &&
                        <div>
                            {statusMsgCon(Clock, common.statusText.completedOn, props.serie.seriesCompletedAt)}
                        </div>
                    }

                    {isExpired() &&
                        <div>
                            {statusMsgCon(BlackTimer, common.statusText.expiredOn, props.serie.seriesEndAt)}
                        </div>
                    }
                        </>
                    )}

                </div>
                <div
                    style={{ opacity: overLayIcon === WhiteLock ? 0.6 : 1 }}
                    className={subscriptionGroupCard ? "mt-[12px]" : "mt-[7px]"}>
                    <SeriesProgressBar
                        // serie={{progress:99}} // testing
                        serie={props.serie}
                    />
                </div>
            </div>
        </div>
    );
}
